import React, { FC } from 'react';
import Layout from '../components/Layout';

const Home: FC = () => (
  <Layout />
);

export default Home;
